import moment from 'moment';

import { get } from '../../Common/utils';

const dateFormatter = date =>
  !date ? '' : moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD h:mm:ss a');

const visitsFactory = ({ visits = [] }) =>
  visits.map(visit => ({
    receivedOn: dateFormatter(get(visit, 'receivedOn', '')),
    agencyName: get(visit, 'agencyName', ''),
    partnerName: get(visit, 'partnerName', ''),
    originalReferenceNumber: get(visit, 'originalReferenceNumber', ''),
    visitID: get(visit, 'visitID', ''),
    status: get(visit, 'status', ''),
    visitStatus: get(visit, 'visitStatus', ''),
    aggregatorID: get(visit, 'aggregatorID', ''),
    errorMessage: get(visit, 'errorMessage', ''),
    payerID: get(visit, 'payerID', ''),
  }));

const getVisitsTotalRecords = ({ totalRecords = 0 }) => totalRecords;

const normalizeVisits = response => ({
  list: visitsFactory(response),
  totalRecords: getVisitsTotalRecords(response),
});

const normalizeVisitReportsError = ({ message = {} }) => {
  const errors = get(message, 'messages', []);

  return {
    errors,
  };
};

const normalizeVisitsDetails = (visitsDetails = {}) => ({
  overview: {
    visitID: get(visitsDetails, 'visitID', ''),
    referenceNumber: get(visitsDetails, 'referenceNumber', ''),
    agencyName: get(visitsDetails, 'agencyName', ''),
    payerStatus: get(visitsDetails, 'payerStatus', ''),
    partnerName: get(visitsDetails, 'partnerName', ''),
    payerID: get(visitsDetails, 'payerID', ''),
    aggregatorID: get(visitsDetails, 'aggregatorID', ''),
    agencyID: get(visitsDetails, 'agencyID', ''),
    status: get(visitsDetails, 'status', ''),
    receivedOn: dateFormatter(get(visitsDetails, 'receivedOn', '')),
    modifiedOn: dateFormatter(get(visitsDetails, 'modifiedOn', '')),
    payerVisitReceiptID: get(visitsDetails, 'payerVisitReceiptID', ''),
    payerStaffReceiptID: get(visitsDetails, 'payerStaffReceiptID', ''),
    payerPatientReceiptID: get(visitsDetails, 'payerPatientReceiptID', ''),
    ftpFileName: get(visitsDetails, 'ftpFileName', ''),
    sentOn: dateFormatter(get(visitsDetails, 'sentOn', '')),
    statusCheckedOn: dateFormatter(get(visitsDetails, 'statusCheckedOn', '')),
    errorMessage: get(visitsDetails, 'errorMessage', ''),
  },
  aggregatorPayload: get(visitsDetails, 'aggregatorPayload', []),
  visitPayload: get(visitsDetails, 'visitPayload', {}),
  history: get(visitsDetails, 'history', []),
});

const normalizePartners = ({ partners = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    partners.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'partnerID', ''),
    })),
  );

const normalizeAggregators = (aggregators = []) =>
  [{ label: 'All', value: 'ALL' }].concat(
    aggregators.map(agency => ({
      label: get(agency, 'aggregatorID', ''),
      value: get(agency, 'aggregatorID', ''),
    })),
  );

const normalizeAgencies = ({ agencies = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    agencies.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'agencyID', ''),
    })),
  );

export {
  normalizeVisits,
  normalizePartners,
  normalizeAggregators,
  normalizeAgencies,
  normalizeVisitsDetails,
  normalizeVisitReportsError,
};
